var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImagePlay = function SvgImagePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m0 0 15.825 8.001 15.826 7.997-15.826 8.001L0 32V15.998z"
  })));
};
export { SvgImagePlay as ReactComponent };
export default __webpack_public_path__ + "assets/ImagePlay.148e4acce33ca9c47c57cab5c5c242d2.svg";